import useSisenseScmLcmEventNoCourseDropdown from "./UseSisenseScmLcmEventNoCourseDropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseScmLcmEventNoCourseDropdown = ({ label, name, value, error, message, onChange }) => {
  const { scmLcmEventNoCourseOptions } = useSisenseScmLcmEventNoCourseDropdown();

  return !scmLcmEventNoCourseOptions.options
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={scmLcmEventNoCourseOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={!scmLcmEventNoCourseOptions.options}
      />
    );
};

export default SisenseScmLcmEventNoCourseDropdown;